import EdverumTable from '@/store/utilities/EdverumTable.js';

const collectionHelpers = EdverumTable.collection('Course');

export default {
    state: {
        ...EdverumTable.search.state,
        ...EdverumTable.searchTag.state,
        ...EdverumTable.searchGroup.state,
        ...EdverumTable.searchCourseCode.state,
        ...EdverumTable.searchInstructor.state,
        ...EdverumTable.courseKeyEnabled.state,
        ...EdverumTable.inProgress.state,
    },

    getters: {
        ...EdverumTable.search.getters,
        ...EdverumTable.searchTag.getters,
        ...EdverumTable.searchGroup.getters,
        ...EdverumTable.searchInstructor.getters,
        ...EdverumTable.searchCourseCode.getters,
        ...EdverumTable.courseKeyEnabled.getters,
        ...EdverumTable.inProgress.getters,
    },

    actions: {
        fetchAssignableTags: EdverumTable.searchTag.actions.fetchAssignableTags('/api/tags?type=course&model=Course'),
        fetchAssignableGroups: collectionHelpers.actions.fetchAssignableGroups(),
        fetchAssignableCourseCodes: collectionHelpers.actions.fetchAssignableCourseCodes(),
        reset: collectionHelpers.actions.reset('Courses'),
    },

    mutations: {
        ...EdverumTable.search.mutations,
        ...EdverumTable.searchInstructor.mutations,
        ...EdverumTable.searchTag.mutations,
        ...EdverumTable.searchGroup.mutations,
        ...EdverumTable.searchCourseCode.mutations,
        ...EdverumTable.courseKeyEnabled.mutations,
        ...EdverumTable.inProgress.mutations,
        SET_ASSIGNABLE_GROUPS: collectionHelpers.mutations.SET_ASSIGNABLE_GROUPS,
    },
};
